import React, { ReactNode } from 'react';
import { MenuItem, Select, Stack } from '@mui/material';
import { Control, FieldValues, Path } from 'react-hook-form';
import { CurrencyInputField, InputField, SelectField } from 'components/form';
import { CustomScorecardCriteriaType } from '../../../../../pages/LenderWaterfall/ScorecardBuilder/types';

interface Props<FormValues extends FieldValues> {
  leftSlot?: ReactNode;
  rightSlot?: ReactNode;
  name: Path<FormValues>;
  control: Control<FormValues>;
  type: CustomScorecardCriteriaType;
}

export const CustomCriteriaBodyCell = <FormValues extends FieldValues = FieldValues>(props: Props<FormValues>) => {
  const { name, type, control, leftSlot, rightSlot } = props;

  const renderFields: Record<CustomScorecardCriteriaType, ReactNode> = {
    [CustomScorecardCriteriaType.Text]: (
      <InputField
        name={name}
        control={control}
        label="Text value"
        inputProps={{ variant: 'outlined', placeholder: 'Enter text value...' }}
      />
    ),
    [CustomScorecardCriteriaType.Number]: (
      <>
        <InputField
          label="Min value"
          control={control}
          name={`${name}.number.min` as Path<FormValues>}
          inputProps={{ type: 'number', variant: 'outlined' }}
        />

        <InputField
          label="Max value"
          control={control}
          name={`${name}.number.max` as Path<FormValues>}
          inputProps={{ type: 'number', variant: 'outlined' }}
        />
      </>
    ),
    [CustomScorecardCriteriaType.Currency]: (
      <>
        <CurrencyInputField
          control={control}
          label="Min value"
          name={`${name}.number.min` as Path<FormValues>}
          textFieldProps={{ size: 'small', fullWidth: true, variant: 'outlined' }}
        />

        <CurrencyInputField
          label="Max value"
          control={control}
          name={`${name}.number.max` as Path<FormValues>}
          textFieldProps={{ size: 'small', fullWidth: true, variant: 'outlined' }}
        />
      </>
    ),
    [CustomScorecardCriteriaType.Boolean]: (
      <SelectField
        name={name}
        control={control}
        label="Select"
        placeholder="Enter Yes or No"
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
      />
    ),
  };

  return (
    <Stack width="100%" direction="row" gap="0.5rem" alignItems="center">
      {leftSlot && leftSlot}
      {renderFields[type]}
      {rightSlot && rightSlot}
    </Stack>
  );
};
